export const firebaseConfig = {
  apiKey: 'AIzaSyCWj-TK3cLWG2TuTRxX_0F7FHYQ21DXCIU',
  authDomain: 'inshuwa.firebaseapp.com',
  projectId: 'inshuwa',
  storageBucket: 'inshuwa.firebasestorage.app',
  messagingSenderId: '651089865706',
  appId: '1:651089865706:web:f300b12d7b4e56ab97e093',
  measurementId: 'G-H0W9T29WQ1',
};
/**
 * The web push certificate's public key (Firebase console > Project settings > Cloud Messaging > Web
 * configuration). Public by design; web push stays off while it's empty.
 */
export const webPushVapidKey = 'BMaYErBBJWM6EGngWKJdoOKKfjfQ7OqsskRvXT0GJqWaSlEkMFQul8fkyk2mAfts75JgWWo0_-DHBIFqriETrqc';

